import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class ChatRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);
	
	getHistory(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/recent', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getChatByFriendId(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/withUser/' + params.friendUserId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getChatById(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/' + params.id + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getChatPostById(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/post/' + params.id + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getConversationMessages(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/post/byChat/' + params.chatId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	sendTextMessage(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/update/forUser/' + params.forUser + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateChatMessage(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/updateChatMessage/forUser/' + params.forUser + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createBookingOfferFromChat(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/booking/offer/forUser/' + params.forUser + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	acceptBookingOffer(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/booking/offer/' + params.bookingOfferId + '/accept', {}, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	declineBookingOffer(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/booking/offer/' + params.bookingOfferId + '/decline', {}, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	cancelBookingOffer(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/booking/offer/' + params.bookingOfferId + '/cancel', {}, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	sendNewMessagesNotification(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/notify', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	sendChatEvent(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/event', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	poll(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/post/newWithEvents', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadImageToChat(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/' + params.id + '/picture', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadImageToFriend(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/user/' + params.id + '/picture', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadDocumentToChat(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/' + params.id + '/document', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadDocumentToFriend(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/user/' + params.id + '/document', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadVideoToChat(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/' + params.id + '/video', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	uploadVideoToFriend(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/user/' + params.id + '/video', data, {
			params: params,
			withCredentials: true,
			
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	updateLastPostSeen(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/last/post/seen', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getConsultant(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/mental/health/consultant/with/chatbot', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	sendPostToConsultant(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/post/consultant', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	toggleChatDisabled(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/chat/toggle/disabled', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getExtraInfo(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/' + params.userId + '/extraInfo', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getBotSummary(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/bot/' + params.chatId + '/summary', {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	disableChatBot(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/chat/bot/disabled', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	translate(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/chat/translate', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
}
